var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"notfound"}},[_vm._v("找不到頁面 ddddd")])}
var staticRenderFns = []

export { render, staticRenderFns }